<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              library_books
            </v-icon>
            <span class="title">Data Kamus</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Data
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Tambah Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
            <v-tab href="#tab-import">
              Import Data
              <v-icon large>cloud_upload</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editKamus(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddkamus"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkamus.vocab_en"
                                :rules="[rules.required]"
                                label="Istilah EN"
                                name="istilahen"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkamus.vocab_id"
                                :rules="[rules.required]"
                                label="Istilah ID"
                                name="istilahid"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addkamus.desc_en"
                                auto-grow
                                label="Deskripsi EN"
                                rows="1">
                              </v-textarea>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addkamus.desc_id"
                                auto-grow
                                label="Deskripsi ID"
                                rows="1">
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-import">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertcheck"></alertsp>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-file-input
                          v-model="impdata.file"
                          :hint="'Pilih file data'"
                          persistent-hint
                          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          label="Select"
                          show-size>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          :disabled="loading.impcheck"
                          large
                          block
                          color="primary"
                          class="mt-1"
                          @click="uploadDataCheck">
                          <v-icon left dark>cloud_upload</v-icon>
                          Upload
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          color="yellow"
                          :href="urltemplate"
                          target="_blank"
                          class="mt-1">
                          <v-icon left dark>cloud_download</v-icon>
                          Template
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="loading.impcheck || loading.impsubmit">
                      <v-col cols="12" class="text-center">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </v-col>
                    </v-row>
                    <v-row v-if="!loading.impsubmit && impresult">
                      <v-col cols="12">
                        <v-simple-table class="mt-3">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Total data</th>
                                <th class="text-left">Berhasil</th>
                                <th class="text-left">Duplikat Data</th>
                                <th class="text-left">Gagal</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <b>{{ impresult.total }}</b>
                                </td>
                                <td>
                                  <b>{{ impresult.berhasil }}</b>
                                </td>
                                <td>
                                  <b>{{ impresult.nikexist }}</b>
                                  <span v-if="impresult.nikexistarr.length > 0">
                                    ( {{ impresult.nikexistarr.join(', ') }} )
                                  </span>
                                </td>
                                <td>
                                  <b>{{ impresult.other }}</b>
                                  <span v-if="impresult.otherarr.length > 0">
                                    ( {{ impresult.otherarr.join(', ') }} )
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-row v-if="!loading.impcheck">
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="impdata.search"
                          prepend-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          :disabled="!impdata.data.length || loading.impsubmit"
                          large
                          block
                          color="success"
                          class="mt-1"
                          @click="importData">
                          <v-icon left dark>import_export</v-icon>
                          Import
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          :disabled="!impdata.data.length || loading.impsubmit"
                          large
                          block
                          color="error"
                          class="mt-1"
                          @click="clearDataRes">
                          <v-icon left dark>clear</v-icon>
                          Clear
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="!loading.impcheck">
                      <v-col cols="12">
                        <v-data-table
                          :headers="headerimp"
                          :items="impdata.data"
                          :search="impdata.search">
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.kamus"
      max-width="700px"
      v-if="dmodaldata.kamus">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update data kamus</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatekamus"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kamus.vocab_en"
                        :rules="[rules.required]"
                        label="Istilah EN"
                        name="istilahen"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kamus.vocab_id"
                        :rules="[rules.required]"
                        label="Istilah ID"
                        name="istilahid"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.kamus.desc_en"
                        auto-grow
                        label="Deskripsi EN"
                        rows="1">
                      </v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.kamus.desc_id"
                        auto-grow
                        label="Deskripsi ID"
                        rows="1">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statusdata"
                        v-model="dmodaldata.kamus.status_vocab"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('kamus')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'KamusAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertcheck: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      impcheck: false,
      impsubmit: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Istilah EN', value: 'vocab_en' },
      { text: 'Istilah ID', value: 'vocab_id' },
      { text: 'Status', value: 'status_vocab' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    headerimp: [
      { text: 'Istilah en', value: 'vocab_en' },
      { text: 'Istilah id', value: 'vocab_id' },
      { text: 'Deskripsi en', value: 'desc_en' },
      { text: 'Deskripsi id', value: 'desc_id' },
    ],
    datalist: [],
    addkamus: {
      vocab_en: '',
      vocab_id: '',
      desc_en: '',
      desc_id: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    impdata: {
      file: null,
      data: [],
      search: '',
    },
    impresult: null,
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
    },
    tabdata: null,
    dmodal: {
      kamus: false,
    },
    dmodaldata: {
      kamus: null,
    },
    urltemplate: '',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getKamus();
    this.$store.commit('UPDATE_TITLE', 'Data Kamus');
    this.urltemplate = this.api + '/upload/template/importdata.xlsx';
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getKamus() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kamus/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddkamus.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/kamus/',
              qs.stringify(
                this.addkamus,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddkamus.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Istilah "' + resdata.data + '" berhasil ditambahkan!';
                  this.getKamus();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'kamus') {
        this.dmodal.kamus = false;
      } else {
        this.dmodal.kamus = false;
      }
    },
    editKamus(item) {
      this.alertupdate.show = false;
      this.dmodal.kamus = true;
      this.dmodaldata.kamus = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatekamus.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/kamus/',
              qs.stringify(
                this.dmodaldata.kamus,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = 'Data "' + this.dmodaldata.kamus.vocab_en + '" berhasil diubah!';
                  this.getKamus();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    uploadDataCheck() {
      this.impdata.data = [];
      this.loading.impcheck = true;
      this.alertcheck.show = false;
      if (this.tokenscr && this.impdata.file) {
        const dataadd = this.impdata;
        const formData = new FormData();
        // file
        formData.append('file_upload', dataadd.file);
        this.axios
          .post(
            this.api + '/api/kamus/uploadcheck',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  // console.log(resdata.data);
                  let datalist = null;
                  for (let i = 1; i < resdata.data.length; i++) {
                    datalist = {
                      vocab_en: resdata.data[i][0],
                      vocab_id: resdata.data[i][1],
                      desc_en: resdata.data[i][2],
                      desc_id: resdata.data[i][3],
                    };
                    this.impdata.data.push(datalist);
                  }
                }
              } else {
                this.alertcheck.show = true;
                this.alertcheck.type = 'error';
                this.alertcheck.text = resdata.message;
              }
            } else {
              this.alertcheck.show = true;
              this.alertcheck.type = 'error';
              this.alertcheck.text = 'Internal services error!';
            }
            this.loading.impcheck = false;
          })
          .catch((error) => {
            this.loading.impcheck = false;
            this.alertcheck.show = true;
            this.alertcheck.type = 'error';
            this.alertcheck.text = 'Internal services error!';
          });
      } else {
        this.loading.impcheck = false;
        this.alertcheck.show = true;
        this.alertcheck.type = 'error';
        this.alertcheck.text = 'Invalid data!';
      }
    },
    clearDataRes() {
      this.impdata.data = [];
      this.impdata.search = '';
      this.impdata.file = null;
      this.impresult = null;
    },
    importData() {
      this.alertcheck.show = false;
      this.impresult = null;
      if (this.impdata.data.length > 0) {
        this.loading.impsubmit = true;
        // console.log(this.impdata.data);
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/kamus/import',
              qs.stringify(
                {
                  listdata: this.impdata.data,
                },
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.impresult = resdata.data;
                  this.getKamus();
                  // console.log(this.impresult);
                } else {
                  this.alertcheck.show = true;
                  this.alertcheck.type = 'error';
                  this.alertcheck.text = resdata.message;
                }
              } else {
                this.alertcheck.show = true;
                this.alertcheck.type = 'error';
                this.alertcheck.text = 'Internal services error!';
              }
              this.loading.impsubmit = false;
            })
            .catch((error) => {
              this.loading.impsubmit = false;
              this.alertcheck.show = true;
              this.alertcheck.type = 'error';
              this.alertcheck.text = 'Internal services error!';
            });
        } else {
          this.loading.impsubmit = false;
          this.alertcheck.show = true;
          this.alertcheck.type = 'error';
          this.alertcheck.text = 'Invalid token!';
        }
      } else {
        this.alertcheck.show = true;
        this.alertcheck.type = 'error';
        this.alertcheck.text = 'Data kosong!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
